import React, { useState, useEffect, useRef } from "react";
import "../../Agents/Agents.css";
import Form from "react-bootstrap/Form";
import { Button} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { submitChampionRequest } from "../../../../../store/features/actions/championAgentActions";
import { useParams } from "react-router-dom";
import * as FeatherIcon from "react-feather";
import { FetchSpotContactsRequest } from '../../../../../store/features/actions/targetedReachout/spotContactsActions';
import { useUser } from '../../../../../context/UserContext';
import iq_api_v2 from "../../../../../services/iqApiV2";
import qs from "qs";
import GettingPrepared from "../../Nudges/gettingPrepared";
import CircularLoader from "../../../../HtmlElements/CircularLoader";
import './ChampionCard.css'

export default function ChampionCard({opportunityId, opportunityName, contact_name, designation = ""}) {
  const { clientName, accountName } = useParams();
  const { user } = useUser();
  const dispatch = useDispatch();
  const { loading, successMessage, errorMessage } = useSelector(state => state.championReducer);
  const { spotContactsData, spotContactsLoading } = useSelector(state => state?.spotContactsReducer);
  const hasFetched = useRef(false);

  const [contact, setContact] = useState("");
  const [orgDesignation, setOrgDesignation] = useState("");
  const [context, setContext] = useState("");
  const [file, setFile] = useState(null);
  const [error, setError] = useState({ contact: "", context: "", file: "" });
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [count, setCount] = useState(0);
  const [successResponse, setSuccessResponse] = useState("")
  const [isChampionNoteHtmlLoaded, setIsChampionNoteHtmlLoaded] = useState(false)
  // useEffect(() => {
  //     if(spotContactsData.length){
  //       const contatc_result = spotContactsData.map(({ _id, name }) => ({ _id, name }));
  //       setContacts(contatc_result);
  //     }
  // }, [spotContactsData]);

  useEffect(() => {

    if(typeof successMessage !== "boolean" && successMessage !== ""){
      setSuccessResponse(successMessage)
      setIsChampionNoteHtmlLoaded(true)
    }
  }, [successMessage])

  useEffect(() => {
    setContact(contact_name);
    setContext("");
    setSuccessResponse("")
    setIsChampionNoteHtmlLoaded(false)
  }, [contact_name]);

  useEffect(() => {
    setOrgDesignation(designation);
  }, [designation]);

  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];
    if (uploadedFile && uploadedFile.type !== "application/pdf") {
      setError(prev => ({ ...prev, file: "Only PDF files are allowed." }));
      setFile(null);
    } else {
      setError(prev => ({ ...prev, file: "" }));
      setFile(uploadedFile);
    }
  };

  const downloadChampionNotePdf = () => {
    const formData = {
      contact: contact,
      context: context,
      requestType: "pdf", // pdf / html
      contactOrg: accountName,
      contactDesignation: designation
    };

    dispatch(submitChampionRequest(formData));
    // Clear form after submission
    // setContact("");
    // setContext("");
    // setFile(null);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    let validationErrors = { contact: "", context: "", file: "" };

    if (!contact) validationErrors.contact = "Contact is required.";
    // if (!context) validationErrors.context = "Context is required.";

    if (validationErrors.contact || validationErrors.context) {
      setError(validationErrors);
      return;
    }

    setError({ contact: "", context: "", file: "" });

    const formData = {
      contact: contact,
      context: context,
      requestType: "html", // pdf / html
      contactOrg: accountName,
      contactDesignation: designation
    };

    dispatch(submitChampionRequest(formData));

    // Clear form after submission
    // setContact("");
    // setContext("");
    // setFile(null);

  };

  return  <div className="agents_wrapper m-2">

    {loading && <div
      className="pt-4"
      style={{
        position: 'fixed',
        top: '16px',
        right: '16px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: '12px',
        zIndex: 9999,
        pointerEvents: 'none', // so background stays clickable
      }}
    >
      <CircularLoader />
    </div>
    }

    <div className="custom_card_block mb-2">
      <div className="closure_note_wrapper">
        <div className="head_top">
          <h5 className="main_head">Champion Note</h5>
        </div>
        <div className="closure_block mt-3">

          {isChampionNoteHtmlLoaded == true && 
            <div className="note-content w-100">
              <div className="row">
                <div className="col-md-12 text-right align-right">
                  
                  <div class="prev_next_block">
                  <Button
                      style={{'textAlign': 'left !important', minWidth: '50px'}}
                      variant="secondary"
                      className="btn btn-secondary cancel_modal_btn mr-2 align-left text-left"
                      onClick={(e) => {
                        // setContact("");
                        // setContext("");
                        // setFile(null);
                        setSuccessResponse("")
                        setIsChampionNoteHtmlLoaded(false)
                      }}
                    >
                      <FeatherIcon.ChevronLeft className="font12" style={{
                        marginTop: '-3px',
                        fontSize: '12px !important',
                        height: '17px'
                      }} />
                       Back
                  </Button>

                  <Button
                      disabled={loading}
                      style={{'textAlign': 'left !important', }}
                      variant="secondary"
                      className="genrate_modal_btn btn btn-primary"
                      onClick={(e) => {
                        downloadChampionNotePdf();
                      }}
                    >
                      <FeatherIcon.Download style={{
                        marginTop: '-3px',
                        fontSize: '12px !important',
                        height: '17px'
                      }} /> Download
                  </Button>
                  </div>

                  

                </div>
              </div>
              <div className="closure_result mt-2 table-responsive" dangerouslySetInnerHTML={{ __html: successResponse }} />
            </div>
          }

          {console.log("isChampionNoteHtmlLoaded : ", isChampionNoteHtmlLoaded)}
          {isChampionNoteHtmlLoaded == false && 
          <Form onSubmit={handleSubmit}>
            <div className="row">

              <div className="col-md-6 d-none">
                <Form.Group className="mb-3 custom_agentform_group">
                  <Form.Label className="custom_agentform_label">Select Contact{" "} 
                  <span className='red'>*</span>
                  </Form.Label>
                  <Form.Select
                    className="custom_agentform_control"
                    value={contact}
                    // onChange={(e) => setContact(e.target.value)}
                    onChange={(e) => {
                      setContact(e.target.value);
                      if (e.target.value) setError(prev => ({ ...prev, contact: "" }));
                    }}
                  >
                    <option value="">Select Contact</option>
                    {contacts.length && contacts.map((contact, index) => (
                        <option key={index} value={contact?.name}>
                            {contact?.name}
                        </option>
                    ))}
                    {/* <option key={0} value="Eric Doerr">
                      Eric Doerr
                    </option> */}
                  </Form.Select>
                  {error.contact && <p className="text-danger">{error.contact}</p>}
                </Form.Group>
              </div>
              <div className="col-md-6 d-none">
                <Form.Group className="mb-3 custom_agentform_group">
                  <Form.Label className="custom_agentform_label d-block">Sample Champion Note</Form.Label>
                  <input type="file" className="custom_agentform_file" onChange={handleFileChange} />
                  {error.file && <p className="text-danger">{error.file}</p>}
                </Form.Group>
              </div>

              <div className="col-md-12">
                <Form.Group className="mb-3 custom_agentform_group">
                  <Form.Label className="custom_agentform_label">Provide additional context</Form.Label>
                  {/* <span className='red'>*</span> */}
                  <Form.Control
                    as="textarea"
                    className="contextArea"
                    placeholder="Include deal specifics and any additional context here"
                    rows={3}
                    value={context}
                    // onChange={(e) => setContext(e.target.value)}
                    onChange={(e) => {
                      setContext(e.target.value);
                      if (e.target.value) setError(prev => ({ ...prev, context: "" }));
                    }}
                  />
                  {error.context && <p className="text-danger">{error.context}</p>}
                </Form.Group>
              </div>
              <div className="col-md-12">
                <div className="prev_next_block">
                  <button type="submit" className="genrate_modal_btn btn btn-primary mr-2" disabled={loading}>
                    {loading ? "Generating..." : "Generate"}
                  </button>
                  <button type="reset" className="btn btn-secondary cancel_modal_btn" onClick={() => {
                    setContact("");
                    setContext("");
                    setFile(null);
                    setError({ contact: "", context: "", file: "" });
                  }}>
                    Clear
                  </button>
                </div>
              </div>
              {/* {successMessage && <p className="text-success">{successMessage}</p>} */}
              {errorMessage && <p className="text-danger">{errorMessage}</p>}
            </div>
          </Form>
          }
        </div>
      </div>
    </div>
    </div>
}